import type { DateCursor } from '@integrations/core'
import moment from '@integrations/date-time'
import { RecurringSteps } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

export function getRecurringFrequencyOptions() {
  return [
    { label: tr('FRONTEND.RECURRING.FREQUENCY.WEEKLY', 'Weekly'), value: RecurringSteps.WEEKLY },
    { label: tr('FRONTEND.RECURRING.FREQUENCY.BI_WEEKLY', 'Biweekly'), value: RecurringSteps.BI_WEEKLY },
    { label: tr('FRONTEND.RECURRING.FREQUENCY.MONTHLY', 'Monthly'), value: RecurringSteps.MONTHLY },
    { label: tr('FRONTEND.RECURRING.FREQUENCY.YEARLY', 'Yearly'), value: RecurringSteps.YEARLY }
  ]
}

export function getRecurringFrequencyLabel(recurringStep: string): string {
  return getRecurringFrequencyOptions().find((option) => option.value === recurringStep)?.label ?? recurringStep
}

export function getNextRecurringExecutionDate(startDate: string, recurringStep: string): DateCursor {
  const date = moment(startDate)

  switch (recurringStep) {
    case RecurringSteps.WEEKLY:
      return date.add(1, 'week')
    case RecurringSteps.BI_WEEKLY:
      return date.add(2, 'weeks')
    case RecurringSteps.MONTHLY:
      return date.add(1, 'month')
    case RecurringSteps.YEARLY:
      return date.add(1, 'year')
    default:
      return date
  }
}

export function getRecurringFrequencyDescription(startDate: string, recurringStep: string): string {
  const date = moment(startDate)

  switch (recurringStep) {
    case RecurringSteps.WEEKLY:
      return tr('FRONTEND.RECURRING.FREQUENCY_DESCRIPTION.WEEKLY', 'Every week on {{DAY}}', {
        DAY: date.format('dddd')
      })
    case RecurringSteps.BI_WEEKLY:
      return tr('FRONTEND.RECURRING.FREQUENCY_DESCRIPTION.BI_WEEKLY', 'Every 2 weeks on {{DAY}}', {
        DAY: date.format('dddd')
      })
    case RecurringSteps.MONTHLY:
      return tr('FRONTEND.RECURRING.FREQUENCY_DESCRIPTION.MONTHLY', 'Every month on day {{DAY}}', {
        DAY: date.date()
      })
    case RecurringSteps.YEARLY:
      return tr('FRONTEND.RECURRING.FREQUENCY_DESCRIPTION.YEARLY', 'Every year on {{DATE}}', {
        DATE: date.format('MMM D')
      })
    default:
      return getRecurringFrequencyLabel(recurringStep)
  }
}
